import { IconName } from '@optimus-web/icons';
import { LocalizedText, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { TooltippedIconButton } from '@mews-commander/ui';
import { downloadFile } from '@mews-commander/utils';

export const ExportUsersButton = () => {
    const exportUsers = useRepositoryMutation('userProfiles', 'getAllExport', {
        onSuccess: (data) => {
            downloadFile(data);
            showSuccessAlert({
                description: <LocalizedText textKey={TextKey.FileDownloadWillBegin} />,
                title: <LocalizedText textKey={TextKey.ExportCompleted} />,
            });
        },
    });

    return (
        <TooltippedIconButton
            onClick={() => exportUsers.mutate({})}
            tooltip={<LocalizedText textKey={TextKey.ExportToExcel} />}
            variant="tertiary"
            icon={IconName.Exports}
            loading={exportUsers.isPending}
            type="button"
        />
    );
};
